import { FC, useRef } from 'react';
import useIntersection from '@/hooks/useIntersection';
import Divider from '@/components/UI/divider/Divider';
import Box from '@/components/UI/box/Box';
import { ProductItemTypes } from '@/components/houses/_types/productItem.types';
import ReviewsContainer from '@/components/houses/_reusable/houseInfo/reviews/reviewsContainer/ReviewsContainer';

// const ReviewsContainer = dynamic(
//   () => import('./reviewsContainer/ReviewsContainer'),
//   {
//     ssr: false,
//     loading: () => <ReviewsSkeleton />,
//   },
// )

type ReviewsProps = {
  props: ProductItemTypes;
};
const Reviews: FC<ReviewsProps> = ({
  props
}) => {
  const ref = useRef<HTMLElement | null>(null);
  const isVisible = useIntersection(ref, '100px', true);
  return <Box ref={ref} id="comments" component={'section'} data-sentry-element="Box" data-sentry-component="Reviews" data-sentry-source-file="Reviews.tsx">
      {isVisible && <ReviewsContainer product={props} />}
      <Divider data-sentry-element="Divider" data-sentry-source-file="Reviews.tsx" />
    </Box>;
};
export default Reviews;